"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleCosyImage = void 0;
var VehicleCosyImage = /** @class */ (function () {
    function VehicleCosyImage() {
    }
    return VehicleCosyImage;
}());
exports.VehicleCosyImage = VehicleCosyImage;
